var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"special-sale-item"},[_c('div',{staticClass:"banner"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.banner),expression:"banner"}]})]),_c('sku-list',{attrs:{"sku-list":_vm.skuList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }